import BaseEntityService from '../core/base-entity-service';

export default class TradeService extends BaseEntityService {
  static override route = 'trade';
}
